// extracted by mini-css-extract-plugin
module.exports = {"player-icon-mask":"eD","playerIconMask":"eD","player-icon-box":"eE","playerIconBox":"eE"};